import { useEffect } from 'react';
import { Card } from '../ui/Card.jsx';
import { Button } from '../ui/Button.jsx';
import { useAudio } from '../../hooks/useAudio.js';

export function GameOverCard({ won, day, ending, onRestart }) {
  const audio = useAudio();

  // Use ending system if available, otherwise fall back to legacy won/lost
  const displayEnding = ending || {
    type: won ? 'victory' : 'defeat',
    icon: won ? '🏆' : '💀',
    title: won ? 'Victory!' : 'Defeat',
    message: won
      ? `You survived ${day} days! Your settlement thrives!`
      : `Your settlement fell on day ${day}. The wilderness claims another...`,
    color: won ? 'text-green-700' : 'text-red-700'
  };

  // Play victory/defeat music when component mounts
  useEffect(() => {
    if (won) {
      audio.playSound('music_victory');
    } else {
      audio.playSound('music_defeat');
    }
  }, [won, audio]);

  return (
    <Card title={displayEnding.title} icon={displayEnding.icon}>
      <div className="text-center mb-6">
        <div className={`text-4xl mb-4 ${displayEnding.color}`}>
          {displayEnding.icon}
        </div>
        <h2 className={`text-2xl font-bold mb-4 ${displayEnding.color}`}>
          {displayEnding.title}
        </h2>
        <p className="text-lg text-amber-800 mb-4">
          {displayEnding.message}
        </p>
        {displayEnding.flavor && (
          <p className="text-sm text-amber-600 italic mt-2">
            {displayEnding.flavor}
          </p>
        )}
      </div>
      <div className="text-center">
        <Button onClick={onRestart}>Play Again</Button>
      </div>
    </Card>
  );
}
